var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.79,
    height: 23.488,
    viewBox: "0 0 18.79 23.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "description_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "description_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M164.668,194.5h9.454v-1.762h-9.454Zm0-4.991h9.454v-1.762h-9.454Zm-2.907,9.982A1.806,1.806,0,0,1,160,197.726V177.762A1.806,1.806,0,0,1,161.762,176h10.6l6.43,6.43v15.3a1.806,1.806,0,0,1-1.762,1.762Zm9.718-16.265v-5.461h-9.718v19.964h15.267v-14.5Zm-9.718-5.461v0Z",
    transform: "translate(-160 -176)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyIcon);
export default __webpack_public_path__ + "static/media/apply-icon.57a13b9675b5a23e327193a384ddb802.svg";
export { ForwardRef as ReactComponent };